export const EventCategory = {
	Search: 'Search',
	Library: 'Library',
	DocViewer: 'DocViewer'
};
